import axios from "axios";
import router from "@/router";

const getDefaultState = () => {
  return {
    allCustomers: [],
    allCustomersLoading: false,
    fields: {
      ALL_CUSTOMERS: `
        company_name
        id
        web_app_id
        debiteur_no
        no_devices
      `
    }
  };
};

const state = getDefaultState();

const getters = {
  getAllCustomers(state) {
    return state.allCustomers;
  },
  getAllCustomersLoading(state) {
    return state.allCustomersLoading;
  }
};

const actions = {
  fetchAllCustomers({ commit, dispatch, state }) {
    commit("setAllCustomersLoading", true);

    const data = {
      query: `
        query {
          CustomersAll(limit: 20) { ${state.fields.ALL_CUSTOMERS} }
        }
      `
    };
    const data_1 = {
      query: `
        query {
          CustomersAll(offset: 20) { ${state.fields.ALL_CUSTOMERS} }
        }
      `
    };

    dispatch("fetchCustomers", {
      data: data,
      commit_to: "setAllCustomers"
    }).then(() => {
      dispatch("fetchCustomers", {
        data: data_1,
        commit_to: "setAddToAllCustomers"
      }).then(() => {
        commit("setAllCustomersLoading", false);
      });
    });
  },
  fetchCustomers({ commit, rootGetters }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(rootGetters.getGraphQlUrl, payload.data, rootGetters.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            alert(res.data.errors[0].message);
          } else {
            commit(payload.commit_to, res.data.data.CustomersAll);
          }
        })
        .catch(err => {
          alert(err);
          console.error(err);
        })
        .then(() => {
          resolve();
        });
    });
  },
  fetchCustomersPagination({ state, dispatch }, payload) {
    const commitPayload = {
      this_ref: payload.this_ref,
      data: {
        query: `
          query {
            customers: CustomersOrderPagination (
              limit: ${payload.limit},
              offset: ${payload.offset},
              order: "${payload.order}"
            ) { ${state.fields.ALL_CUSTOMERS} }
          }
        `
      }
    };

    dispatch("fetchCommitCustomers", commitPayload);
  },
  fetchCustomersLikeName({ state, dispatch }, payload) {
    const commitPayload = {
      this_ref: payload.this_ref,
      data: {
        query: `
          query {
            customers: CustomersLikeName(name: "${payload.name}") {
              ${state.fields.ALL_CUSTOMERS}
            }
          }
        `
      }
    };

    dispatch("fetchCommitCustomers", commitPayload);
  },
  fetchCustomersDebiteurNo({ state, dispatch }, payload) {
    const commitPayload = {
      this_ref: payload.this_ref,
      data: {
        query: `
          query {
            customers: CustomersByDebiteurNo(debiteur_no: "${payload.debiteurNo}") {
              ${state.fields.ALL_CUSTOMERS}
            }
          }
        `
      }
    };

    dispatch("fetchCommitCustomers", commitPayload);
  },
  fetchCustomersWebAppId({ state, dispatch }, payload) {
    const commitPayload = {
      this_ref: payload.this_ref,
      data: {
        query: `
          query {
            customers: CustomersByWebAppId(web_app_id: "${payload.webAppId}") {
              ${state.fields.ALL_CUSTOMERS}
            }
          }
        `
      }
    };

    dispatch("fetchCommitCustomers", commitPayload);
  },
  checkForExistingCustomerName({ commit, rootGetters }, payload) {
    return new Promise((resolve, reject) => {
      const data = {
        query: `
          query {
            CustomerCheckExistingName (customer_name: "${payload.customerName}")
          }
        `
      };

      axios
        .post(rootGetters.getGraphQlUrl, data, rootGetters.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            alert(res.data.errors[0].message);
          }
          resolve(res);
        })
        .catch(err => {
          alert(err);
          reject(err);
          console.error(err);
        });
    });
  },
  fetchCommitCustomers({ state, commit, rootGetters, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      commit("setAllCustomersLoading", true);

      axios
        .post(rootGetters.getGraphQlUrl, payload.data, rootGetters.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            res.data.errors.forEach(e => {
              // Check for timeout error to logout
              if (e.message == "Login timeout, logout and login again.") {
                dispatch("auth/logOut", null, { root: true });
                resolve(false);
              }

              dispatch("axios_mod/makeErrorToast", {
                this_ref: payload.this_ref,
                content: e.message != null ? e.message : "Something went wrong."
              }, { root: true });
            });
            resolve(false);
          } else {
            commit('setAllCustomers', res.data.data.customers);
            resolve();
          }
        })
        .catch(err => {
          dispatch("axios_mod/makeErrorToast", {
            this_ref: payload.this_ref,
            content: err != null ? err : "Something went wrong."
          }, { root: true });
          resolve(false);
        })
        .finally(() => { commit("setAllCustomersLoading", false) });
    });
  },
};

const mutations = {
  setAllCustomers(state, customers) {
    state.allCustomers = customers;
  },
  setAddToAllCustomers(state, customers) {
    state.allCustomers.push(...customers);
  },
  setAllCustomersLoading(state, loading) {
    state.allCustomersLoading = loading;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
